export class Pagination
{
    totalElements: number;
    totalPages: number;
    size: number;
    numberOfElements: number;
    pageNumber: number;
    lastPage: boolean;
    firstPage: boolean;
    empty: boolean;
}



